define([
	"dojo/_base/declare",
	"csi/toolbar/MultiSelectSwitchboard"
], function(declare,MultiSelectSwitchboard) {

	return declare(MultiSelectSwitchboard, {
		bDelayInitialization: true,
		disableButtonAction: true,
		idViewProperty: "reviewUrls",
		refreshStoreOptions: true,

		// String: path is relative to SizeChartReviewSize as stated in _getStoreOptions below
		switchboardPath: "Child:ReviewHistory",

		canShowPlugin: function() {
			// summary: return true if only one size selected and there are past reviews of that size
			var size = this._getSingleSize();
			return size ? (size.ReviewHistory && !!size.ReviewHistory.length) : false;
		},

		postCreate: function() {
			// summary: refresh the review store when the selected sizes (columns) changes
			var	self = this;

			this.inherited(arguments);

			this.getView().watch("columnNodeUrls", function() {
				self.refreshStore(self.getViewPropertyValue());
			});
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: hide if printing
			return !ctx.bPrint;
		},

		_getSingleSize: function() {
			// summary: return selected size column url if only 1
			var sizes = this.getView().getActiveSizes();
			return sizes && (sizes.length == 1) ? sizes[0] : null;
		},

		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			// summary: replace url (SizeChartRevision) with that of single selected size (SizeChartReviewSize), otherwise return null
			var node = this._getSingleSize();
			return node ? this.inherited(arguments, [node.$URL, r]) : null;
		}
	});
});